import { Getters } from "vuex";
import { ExchangeResultsGetters, ExchangeResultsState } from "./types";

export const getters: Getters<ExchangeResultsState, ExchangeResultsGetters> =
  {};
